import type {ReactElement} from 'react';
import React from 'react';
import type {ColorFillStorage} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import type {RGBA} from '@Utils/color.util';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';

interface BaseRemovecolorColorOptionProps {
  className?: string;
  removeColorValue: RGBA;
  onClickColorFill(): void;
}

export function BaseRemovecolorColorOption({className = '', ...props}: BaseRemovecolorColorOptionProps): ReactElement<any> | null {
  const getColorDataObject = (): ColorFillStorage[] => {
    return [
      {
        id: 'remove-color-fill-object',
        color: getColorObjectArrayFromFillColor([props.removeColorValue]),
      },
    ];
  };

  return (
    <ContextualMenuColorFillOption
      className={className}
      id="remove-color-fill-option"
      label={window.i18next.t('pmwjs_color')}
      data={getColorDataObject()}
      onClick={(): void => {
        props.onClickColorFill();
      }}
    />
  );
}
